import { Null, Record, String } from 'runtypes';

export const NoteListExtrasRunType = Record({});

export const GroupedStatusRunType = Record({
	calculated: String.Or(Null),
	userList: String.Or(Null),
});
